var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEarnNavHistoryInactive = function SvgEarnNavHistoryInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.727 1.975H4.064c-.864 0-1.564.7-1.564 1.564v16.597c0 .864.7 1.564 1.564 1.564h14.663c.863 0 1.564-.7 1.564-1.564V3.539c0-.864-.7-1.564-1.564-1.564Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.188 7.817h-9.59v.85h9.59v-.85ZM16.188 10.216h-9.59v.85h9.59v-.85ZM16.188 12.61h-9.59v.85h9.59v-.85ZM12.595 15.008H6.598v.85h5.997v-.85Z",
    fill: "#999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.078 25.553a1.395 1.395 0 0 1-2 0l-4.227-4.228a1.396 1.396 0 1 1 1.974-1.974l4.228 4.228a1.397 1.397 0 0 1 .025 1.974Z",
    fill: "#999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.624 19.676a5.408 5.408 0 0 1 0-8.57 5.423 5.423 0 0 1 6.582 0 5.41 5.41 0 0 1 0 8.575 5.412 5.412 0 0 1-6.582-.005Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.717 10.796H9.312l1.963-.85h6.442v.85ZM17.722 12.345h-8.41v.85h8.41v-.85ZM17.722 14.743h-8.41v.85h8.41v-.85ZM14.569 17.142H9.312v.85h5.257v-.85Z",
    fill: "#999"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.053 23.554 23.87 21.37a2.948 2.948 0 0 1-.7-3.138 7.79 7.79 0 0 0-1.629-8.236 7.856 7.856 0 0 0-10.824-.41 7.806 7.806 0 0 0-.31 11.32 7.807 7.807 0 0 0 8.34 1.744 2.999 2.999 0 0 1 3.17.714l2.188 2.189a1.393 1.393 0 0 0 2.159-.225 1.42 1.42 0 0 0-.21-1.774Zm-13.428-3.878a5.408 5.408 0 0 1 0-8.57 5.422 5.422 0 0 1 6.582 0 5.413 5.413 0 0 1 0 8.575 5.412 5.412 0 0 1-6.582-.005Z",
    fill: "#E5E5E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m24.754 22.255-2 1.999 1.325 1.324a1.393 1.393 0 0 0 2 0 1.393 1.393 0 0 0 0-1.999l-1.325-1.324Z",
    fill: "#D8D8D8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m24.747 22.253-1.972 1.971.598.598 1.971-1.972-.597-.597Z",
    fill: "#999"
  })));
};
export default SvgEarnNavHistoryInactive;